
export default {
    name: 'date-filter',
    components: {},
    props: {
        filter_by_date: Object,
        cslug: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            save_loading: false,

            date_filter: {
                single_date: '',
                from_date: '',
                to_date: '',
                from_hour: '',
                to_hour: ''
            },
            from_date_is_greater: false
        }
    },

    watch: {
        from_date() {
            this.from_date_is_greater = false
        },

        to_date() {
            this.from_date_is_greater = false
        }
    },

    computed: {
        
    },

    mounted() {

    },

    methods: {
        async doFilter() {
            this.from_date_is_greater = false
            const isValid = await this.$refs.filter_form.validate();
            if (!isValid) {
                return;
            }

            if (this.date_filter.from_date != '' && this.date_filter.to_date) {
                if (!(this.date_filter.from_date <= this.date_filter.to_date)) {
                    this.from_date_is_greater = true
                    return;
                }
            }

            this.$emit('emitDateFilter', this.date_filter)

            this.date_filter = {
                single_date: '',
                from_date: '',
                to_date: '',
                from_hour: '',
                to_hour: ''
            }
            this.$refs.filter_form.reset()
            this.$refs.date_filter.click()
        }
    }
}